import { createExternalApi } from './apiFactory'

export const driverPerformanceApi = createExternalApi({
  serviceName: 'driver-performance',
})
